import { Component, NgZone, AfterViewInit } from "@angular/core";

import { AlertController, Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { AppService } from "./services/app.service";
import { environment } from "../environments/environment";
import { LocationStrategy } from "@angular/common";
import { ApiserviceService } from "./httpservice/apiservice.service";
import { Router } from "@angular/router";
import { _setStorage } from "./utils/local-storage";
import { STORAGE } from "./constant/storages";

const address_thai = require("../assets/address/address_thai.json");
const package_json = require("../../package.json");
const Country = require("../assets/address/Country.json");

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  host: {
    "(document:mousemove)": "onMouseMove($event)",
  },
})
export class AppComponent implements AfterViewInit {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public appService: AppService,
    private locationStrategy: LocationStrategy,
    private apiService: ApiserviceService,
    public router: Router,
    public alertController: AlertController,
    private ngZone: NgZone
  ) {
    this.platform.ready().then(() => {
      console.log("platform is ready !!!");
      this.initializeApp();
    });
    window.history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      console.log("pressed back in add!!!!!", location.href);

      window.history.pushState(null, null, location.href);
    });
   

  }

  initializeApp() {
    console.log("[initializeApp] platforms: ", this.platform.platforms());
    if (!this.platform.is("desktop")) {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    }

    this.setVersionNumber();

    this.getStorageAddress();
  }

  ngOnInit(): void {
    console.log("ngOnInit =>", window.location.href);

    const urlToken = window.location.href;
    console.log("====urlToken====:", urlToken);
    if (urlToken.split("#").length > 1) {
      console.log(urlToken.split("#"));
      const responseParameters = urlToken.split("#")[1].split("&");
      let parsedResponse: any = {};
      for (var i = 0; i < responseParameters.length; i++) {
        parsedResponse[responseParameters[i].split("=")[0]] =
          responseParameters[i].split("=")[1];
      }
      console.log("parsedResponse #...", parsedResponse);
      
  
      if (
        parsedResponse?.id_token !== undefined &&
        parsedResponse?.id_token !== null
      ) {
        console.log("parsedResponse => ", parsedResponse);
        const bearer = "Bearer " + parsedResponse["id_token"];
        console.log("========= bearer======", bearer);
        _setStorage(STORAGE.TOKEN,parsedResponse["id_token"])
        _setStorage(STORAGE.B2C_TOKEN,bearer)
        this.router.navigate(["/"]);
      } else {
        console.log("unAuthen !!");
        if (parsedResponse?.error) {
          this.ErrorMsg(
            `${parsedResponse?.error || ""} - ${
              parsedResponse?.error_description || ""
            }`
          );
        }
      }
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: async (blah) => {
            this.router.navigate(["/"]);
          },
        },
      ],
    });
    await alert.present();
  }

  setVersionNumber() {
    this.appService.versionNumber = package_json.version;
    this.appService.versionString =
      environment.version_string +
      " " +
      package_json.version +
      package_json.hotfix_version;

    if (environment.dev == true) {
      this.appService.versionString += " DEV";
    }

    console.log(
      "[setVersion] current version is : ",
      this.appService.versionString
    );
  }

  getStorageAddress() {
    this.appService.address_thai = address_thai;
    this.appService.Country = Country;
  }

  onMouseMove(e) {
    console.log("<----- User Idle ----->");
    this.apiService.clearTimeout();

  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.injectScrollbarStyles();
    });
  }

  /**
   * Inject scrollbar styles เข้า Shadow DOM ของทุก ion-content
   * เพราะ ::part(scroll) ไม่รองรับ ::-webkit-scrollbar ใน Chrome
   */
  private injectScrollbarStyles(): void {
    const css = `
      .inner-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
      .inner-scroll::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
      .inner-scroll::-webkit-scrollbar-thumb { background: #999; border-radius: 10px; }
      .inner-scroll::-webkit-scrollbar-thumb:hover { background: #666; }
      .inner-scroll { scrollbar-width: auto; scrollbar-color: #999 #f1f1f1; }
    `;

    // รอ componentOnReady() ก่อน inject เพราะ Stencil สร้าง Shadow DOM แบบ async
    const injectStyle = (ionContent: Element) => {
      const el = ionContent as any;
      if (typeof el.componentOnReady === 'function') {
        el.componentOnReady().then(() => {
          this.appendStyleToShadow(ionContent, css);
        });
      } else {
        // fallback: รอ shadowRoot พร้อม
        setTimeout(() => this.appendStyleToShadow(ionContent, css), 200);
      }
    };

    // Inject ทุก ion-content ที่มีอยู่
    document.querySelectorAll('ion-content').forEach(injectStyle);

    // MutationObserver คอย inject เมื่อมี ion-content ใหม่ (เปลี่ยนหน้า)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            if (node.tagName === 'ION-CONTENT') {
              injectStyle(node);
            }
            node.querySelectorAll?.('ion-content')?.forEach(injectStyle);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  private appendStyleToShadow(ionContent: Element, css: string): void {
    const shadow = ionContent.shadowRoot;
    if (!shadow) return;
    if (shadow.querySelector('#custom-scrollbar-style')) return;
    const style = document.createElement('style');
    style.id = 'custom-scrollbar-style';
    style.textContent = css;
    shadow.appendChild(style);
  }
}
function jwt_decode(arg0: any): any {
  throw new Error("Function not implemented.");
}

